module.exports = __webpack_public_path__ + "057c194d6535456e7efffdc20f1075a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maxbonus.jpg
// module id = 696
// module chunks = 0